module.exports = __webpack_public_path__ + "static/img/5810_phase_function_Paper_Points.6365ba9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5810_phase_function_Paper_Points.png
// module id = UW3y
// module chunks = 0